export default "/Frontend/dist/excel.40c76c487b78f56e8ca2b34b6235f885.svg";